import React from 'react';
import './cintillo.scss';
import { string, bool, any } from 'prop-types';

const Cintillo = ({
  title,
  imgProps = {},
  className = '',
  backgroundColor,
  withScrutiny,
  currentCountPercent,
  updateDate
}) => (
  <div className={`cintillo ${className}`}>
    {title && (
      <div className="flag_container" style={{ backgroundColor }}>
        {Object.keys(imgProps).length !== 0 && (
          <img className="flag_icon" {...imgProps} />
        )}
        <h2 className="flag_text">{title}</h2>
      </div>
    )}
    {withScrutiny && (
      <div className="info_container">
        <div className="info_wrapper">
          <p className="info_text">
            ESCRUTINIO:{' '}
            <span>
              {currentCountPercent && currentCountPercent.replace('.', ',')}%
            </span>
          </p>
          <p className="info_text">
            Actualizado a las:{' '}
            {currentCountPercent ? (
              <span>{updateDate && `${updateDate.slice(0, -3)} h.`}</span>
            ) : (
              <span>--:-- h.</span>
            )}
          </p>
        </div>
      </div>
    )}
  </div>
);

Cintillo.propTypes = {
  className: string,
  title: string,
  imgProps: any,
  backgroundColor: string,
  withScrutiny: bool,
  currentCountPercent: string,
  updateDate: string
};

export default Cintillo;
